import type { FlightLogSectionContext } from '../useFlightLogForm'
import { SignOffBlock } from '../SignOffBlock'

export function SignOffSection({
  context,
  hasPic,
}: {
  context: FlightLogSectionContext
  hasPic: boolean
}) {
  const { values, setValue, readOnly, fieldError } = context

  const phaseHandlers = (key: 'preFlight' | 'postFlight') => ({
    onSign: (dataUrl: string) => {
      setValue(`signOff.${key}.signaturePng`, dataUrl, { shouldDirty: true })
      setValue(`signOff.${key}.signedAt`, new Date().toISOString(), { shouldDirty: true })
    },
    onClear: () => {
      setValue(`signOff.${key}.signaturePng`, null, { shouldDirty: true })
      setValue(`signOff.${key}.signedAt`, null, { shouldDirty: true })
    },
  })

  if (!hasPic) {
    return (
      <p className="text-xs text-content-primary-subtle">
        Assign a PIC in Route &amp; Times to enable sign-off.
      </p>
    )
  }

  return (
    <div className="flex flex-col gap-4">
      <SignOffBlock
        label="Pre flight"
        phase={values.signOff.preFlight}
        readOnly={readOnly}
        {...phaseHandlers('preFlight')}
      />
      <SignOffBlock
        label="Post flight"
        phase={values.signOff.postFlight}
        readOnly={readOnly}
        {...phaseHandlers('postFlight')}
      />
      {fieldError('signOff') && (
        <p className="text-xs text-content-negative-bold">{fieldError('signOff')}</p>
      )}
    </div>
  )
}
